import toast from 'react-hot-toast';
import { requester } from '../../../libs/requester/requester-axios';
import { pizzaWayAPI } from '../../pizzaWayAPI';

const badgeAPI = pizzaWayAPI.injectEndpoints({
    endpoints: (builder) => ({
        deleteBadge: builder.mutation<{ success: boolean; }, { id: number; mode?: string }>({
            async queryFn(payload, { dispatch }) {
                try {
                    const url = payload?.mode ? `/api/badge/admin/delete/${payload.id}/hard` : `/api/badge/admin/delete/${payload.id}`;
                    const { data, isError, message }: any = await requester.delete(url);
                    if (isError) {
                        toast.error(message);
                        throw new Error(message);
                    };
                    return { data };
                } catch (e) {
                    throw e;
                }
            },
            invalidatesTags: ['Badge']
        }),
    }),
    overrideExisting: false,
});

export const { useDeleteBadgeMutation } = badgeAPI;